// extracted by mini-css-extract-plugin
export default {"paginationWrap":"commonTable_paginationWrap__v5wJd","red":"commonTable_red__-lFMr","yellow":"commonTable_yellow__+IU1p","blue":"commonTable_blue__pV3Ac"};